import React from "react";
import { Link } from "react-router-dom";

export default function SiteFooter() {
  const openCookiePreferences = () => {
    if (typeof window === "undefined") return;
    window.dispatchEvent(new Event("open-cookie-preferences"));
  };

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div>
          <strong>Ahorra y respira</strong> · Control financiero práctico para tu economía personal.
        </div>
        <div className="footer-cta-row">
          <Link to="/auth/login" className="btn btn-secondary btn-footer-login">Acceder</Link>
          <Link to="/auth/register" className="btn btn-primary btn-footer-signup">Empezar gratis</Link>
        </div>
        <div className="footer-links">
          <a href="/#pricing">Precios</a>
          <Link to="/que-hace-la-app">Qué hace la app</Link>
          <Link to="/como-empezar-en-5-minutos">Empezar en 5 minutos</Link>
          <Link to="/precios-y-limites">Free vs Pro</Link>
          <Link to="/privacidad-sin-conexion-banco">Privacidad</Link>
          <Link to="/legal/aviso-legal" target="_blank" rel="noopener noreferrer">Aviso legal</Link>
          <Link to="/legal/privacidad-cookies" target="_blank" rel="noopener noreferrer">Privacidad y cookies</Link>
          <Link to="/legal/terminos-suscripcion" target="_blank" rel="noopener noreferrer">Términos y suscripción</Link>
          <button type="button" className="footer-link-button" onClick={openCookiePreferences}>
            Preferencias de cookies
          </button>
          <a href="mailto:soporte@ahorrayrespira.com" target="_blank" rel="noopener noreferrer">Soporte</a>
        </div>
        <small style={{ color: "rgba(226, 232, 240, 0.7)" }}>
          &copy; {new Date().getFullYear()} Ahorra y respira. Todos los derechos reservados.
        </small>
      </div>
    </footer>
  );
}
